"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MapFiltersAdminSaveDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
const spotlight_badge_priority_1 = require("../../utils/spotlight-badge-priority");
const MapFilterConfigItem_dto_1 = require("../response/MapFilterConfigItem.dto");
const SpotlightCurrentVenueConfig_dto_1 = require("../response/SpotlightCurrentVenueConfig.dto");
const SpotlightEligibilityConfig_dto_1 = require("../response/SpotlightEligibilityConfig.dto");
const SpotlightTrendingConfig_dto_1 = require("../response/SpotlightTrendingConfig.dto");
const VenueAggregateWindowsConfig_dto_1 = require("../response/VenueAggregateWindowsConfig.dto");
class MapFiltersAdminSaveDto {}
exports.MapFiltersAdminSaveDto = MapFiltersAdminSaveDto;
__decorate([(0, swagger_1.ApiProperty)({
  type: [MapFilterConfigItem_dto_1.MapFilterConfigItemDto]
}), __metadata("design:type", Array)], MapFiltersAdminSaveDto.prototype, "filters", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'How many venues to return from GET /user/venues/spotlighted after ranking.',
  minimum: 1
}), __metadata("design:type", Number)], MapFiltersAdminSaveDto.prototype, "spotlightVenueCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Ranking priority for spotlight ticker venues (server-only).',
  enum: enums_1.VenueActivityType,
  isArray: true
}), __metadata("design:type", Array)], MapFiltersAdminSaveDto.prototype, "spotlightSortOrder", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'OR rules that determine which venues are spotlight candidates.',
  type: SpotlightEligibilityConfig_dto_1.SpotlightEligibilityConfigDto
}), __metadata("design:type", SpotlightEligibilityConfig_dto_1.SpotlightEligibilityConfigDto)], MapFiltersAdminSaveDto.prototype, "spotlightEligibility", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'How the user checked-in venue is included and ranked in the spotlight ticker.',
  type: SpotlightCurrentVenueConfig_dto_1.SpotlightCurrentVenueConfigDto
}), __metadata("design:type", SpotlightCurrentVenueConfig_dto_1.SpotlightCurrentVenueConfigDto)], MapFiltersAdminSaveDto.prototype, "spotlightCurrentVenue", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'OR rules that determine whether a venue is flagged "Trending" in the spotlight ticker.',
  type: SpotlightTrendingConfig_dto_1.SpotlightTrendingConfigDto
}), __metadata("design:type", SpotlightTrendingConfig_dto_1.SpotlightTrendingConfigDto)], MapFiltersAdminSaveDto.prototype, "spotlightTrending", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Which category wins the ticker card badge when a venue matches more than one (Sponsored, Trending, ' + 'Active check-in, Active event, Current venue) — first match in this order wins.',
  enum: spotlight_badge_priority_1.SPOTLIGHT_BADGE_CATEGORIES,
  isArray: true
}), __metadata("design:type", Array)], MapFiltersAdminSaveDto.prototype, "spotlightBadgePriority", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Time windows for recent check-ins and recent views venue activity stats.',
  type: VenueAggregateWindowsConfig_dto_1.VenueAggregateWindowsConfigDto
}), __metadata("design:type", VenueAggregateWindowsConfig_dto_1.VenueAggregateWindowsConfigDto)], MapFiltersAdminSaveDto.prototype, "venueAggregateWindows", void 0);
//# sourceMappingURL=MapFiltersAdminSave.dto.js.map